module.exports = __webpack_public_path__ + "static/dbAbout.d01be255.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dbAbout.gif
// module id = 222
// module chunks = 35783957827783 263791100135453